<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
// import Tab from "@/components/ar/Tab";
import UploadCallLog from "../Recollect-Automation/upload-call-log.vue";
import UpdateAction from "../Recollect-Automation/update-action.vue";
import manualRemoveP2p from "../Recollect-Automation/manual-remove-p2p.vue";
import { downloadFile } from '@/utils/fileDownloader';
import { exportArrayToCSV } from "@/utils/export/exportCSV";

import Swal from 'sweetalert2';

export default {
    page: {
        title: "New Submission",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            dtKey:0,
            key: '',
            title: "New Submission",
            items: [
                {
                    text: "Recollect Automation",
                    href: "/",
                },
                {
                    text: "New Submission",
                    href: "/",
                },
            ],

            list:[],
            sourceFile: '',
            loadingDetail:true,
            loadingUpload:false,
            ButtonSeen:true,
            PLG_filename:'',
            export:'',
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getlist(){
            this.loadingDetail = true;
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'repayments/submissions/create')
            .then(response => {
                if (response) {
                    this.list = response.data;
                }
            })
            // .catch(error => {
            // })
            .finally(() => {
                this.loadingDetail=false;
            });
        },

        provide() {
            return {
                getList: this.getList, // Provide the function
            };
        },

        add(data) {
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            this.loadingDetail = true;
            axios.post(process.env.VUE_APP_AR_API_BASEURL + 'repayments/exclude/store', { id: data.id, value: data.value })
            .then(response => {
                console.log(response.data);
                // Remove from repaymentList
                const index = this.list.repaymentList.findIndex(item => item.id === data.id);
                if (index !== -1) {
                    const item = this.list.repaymentList.splice(index, 1)[0];
                    item.reason = 'Manual exclude';
                    this.list.excluded.push(item);
                    console.log(this.list);
                }
            })
            .finally(() => {
                this.loadingDetail = false;
            });
        },

        exclude(data) {
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
            this.loadingDetail = true;
            axios.post(process.env.VUE_APP_AR_API_BASEURL + 'repayments/exclude/remove', { id: data.id, value: data.value })
            .then(response => {
                console.log(response.data);
                // Remove from excluded
                const index = this.list.excluded.findIndex(item => item.id === data.id);
                if (index !== -1) {
                    const item = this.list.excluded.splice(index, 1)[0];
                    delete item.reason;
                    this.list.repaymentList.push(item);
                    console.log(this.list);
                }
            })
            .finally(() => {
                this.loadingDetail = false;
            });
        },


        async ApproveAndSendCollection() {
            try {

                await this.getlist();

                const result = await Swal.fire({
                    title: 'Are you sure you want to Approve & Send for Collection?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                });

                if (!result.isConfirmed) {
                    return;
                }

                const posting_ = {
                    data: this.list.repaymentList,
                    type: "recollect",
                };

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');

                const response = await axios.post(process.env.VUE_APP_AR_API_BASEURL + 'repayments/submissions', posting_);

                if (response.status === 200) {
                    await Swal.fire({
                        title: 'Approved & Sent for Collection Successfully!',
                        icon: 'success',
                        timer: 1000,
                        showConfirmButton: false,
                    });
                } else {
                    await Swal.fire({
                        title: 'Failed to Approve & Send for Collection!',
                        icon: 'warning',
                        timer: 1000,
                        showConfirmButton: false,
                    });
                }
            } catch (error) {
                await Swal.fire({
                    title: 'Failed to Approve & Send for Collection!',
                    html: error.response?.data?.msj || 'An error occurred',
                    icon: 'warning',
                    showConfirmButton: true,
                });
            }
        },

        getTotalBalance(item) {
            var total = item.amount + item.late_amount - item.paid_amount - item.credit_amount + item.overpaid_amount;
            return parseFloat(total.toFixed(2));
        },
        exportSubmission(){
            const today = new Date();
            downloadFile(
                process.env.VUE_APP_AR_API_BASEURL + 'repayments/export/submission',
                'repayment recollect '+ today.toISOString().split('T')[0] + '.xlsx'
            );
        },

        async RemovePromiseToPay(id){
            try {
                const result = await Swal.fire({
                    title: 'Are you sure you want to remove this customer from promise to pay?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                });

                if (!result.isConfirmed) {
                    return;
                }
                
                const posting_ = {
                    id: id,
                };

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');

                const response = await axios.post(process.env.VUE_APP_AR_API_BASEURL + 'repayments/calllogs/remove', posting_);

                if (response.status === 200) {
                    await Swal.fire({
                        title: 'Remove Successfully from promise to pay!',
                        icon: 'success',
                        timer: 1000,
                        showConfirmButton: false,
                    });
                    this.list = [];

                    await this.getlist();
                } else {
                    await Swal.fire({
                        title: 'Failed to re,pve promise to pay!',
                        icon: 'warning',
                        timer: 1000,
                        showConfirmButton: false,
                    });
                }
            } catch (error) {
                await Swal.fire({
                    title: 'Failed remove promise to pay!',
                    html: error.response?.data?.msj || 'An error occurred',
                    icon: 'warning',
                    showConfirmButton: true,
                });
            }
        },

        downloadExcludedData() {
            const headers = [
                "Curlec Ref",
                "Invoice / Batch Id",
                "Amount (RM)",
                "Customer Name",
                "Exclusion Reason"
            ];

            const rows = this.list.excluded.map((item) => [
                item.reference_id,
                item.invoiceNo,
                item.amount,
                item.customer_name,
                item.reason
            ]);

            // format date "16 June 2025"
            const today = new Date();
            const options = { day: '2-digit', month: 'long', year: 'numeric' };
            const formattedDate = today.toLocaleDateString("en-GB", options);

            exportArrayToCSV({
                headers,
                rows,
                filename: `excluded-data ${formattedDate}.csv`
            });
        },
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        UploadCallLog,
        UpdateAction,
        manualRemoveP2p,
    },

    mounted() {
        this.getlist();
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingDetail || loadingUpload'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h5 class="card-title mb-0">Recollect Auto-generated Data</h5>
                                    <button class="btn btn-success" @click="exportSubmission">
                                        <i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel
                                    </button>
                                </div>
                                <div class="table-responsive">
                                    <DataTable :options="{ lengthChange: false }" :key="dtKey" class="table table-striped table-nowrap mb-0" id="recollectData">
                                        <thead class="table-secondary">
                                            <tr>
                                                <th>No.</th>
                                                <th>Curlec Ref</th>
                                                <th>Invoice</th>
                                                <th>Monthly Amount (RM)</th>

                                                <th>Late Payment Charge (RM)</th>
                                                <th>Paid Amount (RM)</th>
                                                <th>Credit Note (RM)</th>

                                                <th>Overpaid Amount (RM)</th>
                                                <th>Customer Name</th>
                                                <th>Balance Overdue (RM)</th>

                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in list.repaymentList" :key="item.id" class="content">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ item.mandate_ref }}</td>
                                                <td>{{ item.invoiceNo }}</td>
                                                <td>{{ item.amount }}</td>

                                                <td>{{ item.late_amount }}</td>
                                                <td>{{ item.paid_amount }}</td>
                                                <td>{{ item.credit_amount }}</td>

                                                <td>{{ item.overpaid_amount }}</td>
                                                <td>{{ item.customer_name }}</td>
                                                <td>{{ getTotalBalance(item) }}</td>

                                                <td>
                                                    <UpdateAction :id="item.id" :excludeSwitch="false" @goToFirstPage="add"></UpdateAction>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </DataTable>

                                </div>
                                <div class="table-responsive">
                                    <br>
                                    <div class="card-header border-0 align-items-center d-flex">
                                        <h4 class="card-title mb-0 flex-grow-1">Excluded Data</h4>
                                        <div class="d-flex">
                                            <button @click="downloadExcludedData"
                                                type="button" class="btn btn-outline-success waves-effect waves-light me-2">
                                                Download Excluded Data
                                            </button>
                                            <button data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" 
                                                type="button" class="btn btn-outline-success waves-effect waves-light">
                                                Exclude P2P Customers
                                            </button>
                                        </div>
                                    </div>

                                    <UploadCallLog @refresh-list="getlist"/>
                                    
                                    <DataTable :options="{ lengthChange: false }" :key="dtKey" class="table table-striped table-nowrap mb-0" id="excludeData">
                                        <thead class="table-secondary">
                                            <tr>
                                                <th>No.</th>
                                                <th>Curlec Ref</th>
                                                <th>Invoice / Batch Id</th>
                                                <th>Amount (RM)</th>
                                                <th>Customer Name</th>
                                                <th>Exclusion Reason</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in list.excluded" :key="index" class="content">
                                                <td>{{ index + 1 }}</td>
                                                <td>{{ item.reference_id }}</td>
                                                <td>{{ item.invoiceNo }}</td>
                                                <td>{{ item.amount }}</td>
                                                <td>{{ item.customer_name }}</td>
                                                <td>{{ item.reason }}</td>
                                                <td>
                                                    <UpdateAction :id="item.id" :excludeSwitch="true" @goToFirstPage="exclude" v-if="item.reason == 'Manual exclude'"></UpdateAction>
                                                    <manualRemoveP2p :id="item.id" :excludeSwitch="true" @removePromiseToPay="RemovePromiseToPay(item.id)" v-if="item.reason != 'Manual exclude' && item.reason != 'TIP (Transaction in Progress)'"></manualRemoveP2p>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </DataTable>
                                    <br>
                                    
                                </div>
                                <button @click="ApproveAndSendCollection"
                                    type="button" class="btn btn-outline-success waves-effect waves-light float-end">
                                    Approved & send for collection
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </Layout>
</template>